import fetch from "auth/FetchInterceptor";
import store from "redux/store";
import {
	UPDATE_NOTIFICATIONS,
	UPDATE_MENSAGENS_CHAT_NAO_LIDAS,
} from "redux/constants/Menu";
import { UPDATE_PERMISSOES } from "redux/constants/Permissoes";
import { UPDATE_USER } from "redux/constants/User";
import { UPDATE_CONFIGURACOES } from "redux/constants/Configuracoes";
import * as Sentry from "@sentry/react";
import moment from "moment";
import usuarioService from "./UsuarioService";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const MenuService = {};

/*
    Verifica se a data de última atualização é do mesmo dia que a data atual
    Se não for, faz a request para atualizar
*/
MenuService.verificarEAtualizarDataUltimaAtualizacao = async function (
	dataUltimaAtualizacao,
) {
	const dataAtual = moment();
	let deveAtualizar = false;

	if (!dataUltimaAtualizacao) {
		deveAtualizar = true;
	} else {
		deveAtualizar = !dataAtual.isSame(dataUltimaAtualizacao, "day");
	}

	if (deveAtualizar) {
		try {
			await usuarioService.atualizarUltimaAtividade();
		} catch (error) {
			console.error("Erro ao atualizar data de última atividade:", error);
		}
	}
};

/*
    Injeta na store do usuário os dados do menu
*/
MenuService.populateMenuData = async function () {
	const menuData = await MenuService.getMenuData();

	// Verificar se o usuário está bloqueado e redirecionar para a página de conta bloqueada
	if (menuData.usuario?.bloqueado) {
		// Apenas redireciona se não estiver já na página de conta bloqueada
		if (!window.location.hash.includes("/conta-bloqueada")) {
			window.location.href = `${window.location.origin}/#${APP_PREFIX_PATH}/conta-bloqueada`;
			return; // Interrompe a execução para não continuar processando
		}
	}

	// Estado da assinatura (motor v2): redireciona proativamente como o
	// bloqueado do v1 acima. pendente_ativacao/dormente → checkout do funil
	// (ativação do 9,90); bloqueada → conta bloqueada. O gate do back é o
	// enforcement real; isto é UX (evita o flash do dashboard antes do 403).
	const assinatura = menuData.assinatura;
	if (assinatura?.motor === "v2") {
		if (
			(assinatura.estado === "pendente_ativacao" ||
				assinatura.estado === "dormente") &&
			!window.location.hash.includes("/checkout-oferta")
		) {
			window.location.href = `${window.location.origin}/#/checkout-oferta`;
			return;
		}
		if (
			assinatura.estado === "bloqueada" &&
			!window.location.hash.includes("/conta-bloqueada")
		) {
			window.location.href = `${window.location.origin}/#${APP_PREFIX_PATH}/conta-bloqueada`;
			return;
		}
	}

	// Determinar o role baseado se é funcionário ou não
	let userName = menuData.usuario.nome;
	let userRole = "Usuário";

	if (menuData.funcionario_info && menuData.funcionario_info.e_funcionario) {
		// Para funcionários, mostrar o profissional responsável
		userRole = `Profissional: ${
			menuData.funcionario_info.nome_profissional || "Não identificado"
		}`;
	}

	Sentry.setUser({
		email: menuData.usuario.email,
		id: menuData.usuario.id,
		username: menuData.usuario.nome,
	});
	store.dispatch({
		type: UPDATE_USER,
		id: menuData.usuario.id,
		name: userName,
		role: userRole,
		funcionario_info: menuData.funcionario_info,
		tem_acesso_programa_indicacao:
			menuData.usuario.tem_acesso_programa_indicacao,
		pode_importar_mfit: menuData.usuario.pode_importar_mfit,
		pode_importar_prime: menuData.usuario.pode_importar_prime,
		pode_importar_webdiet: menuData.usuario.pode_importar_webdiet,
		foto_perfil: menuData.usuario.foto_perfil || null,
	});

	store.dispatch({
		type: UPDATE_NOTIFICATIONS,
		notificacoes: menuData.notificacoes || [],
		avisos: menuData.avisos || [],
	});

	store.dispatch({
		type: UPDATE_MENSAGENS_CHAT_NAO_LIDAS,
		total: menuData.mensagens_chat_nao_lidas || 0,
	});

	store.dispatch({
		type: UPDATE_PERMISSOES,
		permissoes: menuData.permissoes,
	});

	store.dispatch({
		type: UPDATE_CONFIGURACOES,
		configuracoes: menuData.configuracoes || {},
	});

	// Redirecionar sócio para o dashboard admin quando estiver na página padrão
	if (menuData.permissoes?.VISUALIZAR_DASHBOARD_ADMIN) {
		const hash = window.location.hash;
		if (
			hash === `#${APP_PREFIX_PATH}/dashboard-profissional` ||
			hash === `#${APP_PREFIX_PATH}` ||
			hash === `#${APP_PREFIX_PATH}/`
		) {
			window.location.href = `${window.location.origin}/#${APP_PREFIX_PATH}/dashboard-admin`;
			return;
		}
	}

	await MenuService.verificarEAtualizarDataUltimaAtualizacao(
		menuData.usuario.data_ultima_atividade,
	);
};

// TODO: após clonar o skeleton, ajustar essa função
MenuService.getMenuData = function () {
	return fetch({
		url: "/v1/rpc/menu",
		method: "get",
	});
};

export default MenuService;
